module.exports = {"320831001":"黎城街道","320831002":"戴楼街道","320831003":"金北街道","320831101":"金南镇","320831103":"塔集镇","320831106":"前锋镇","320831107":"吕良镇","320831111":"银涂镇","320831400":"宝应湖农场","320831401":"复兴圩农场","320831402":"粮棉原种场","320831403":"金湖经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320831.json
// module id = 902
// module chunks = 0